import { RBACService } from '../shared/rbac.service';

/**
 * Whether the user holds the given action on either asset perspective: the account level Asset
 * Register (registers-assets) or a site's Asset Register tab (sites-assets).
 *
 * Assets are reached from both surfaces and both call the same API endpoints, which accept either
 * permission (AssetsController::assetPermissions() in the API). Evaluating the pair with exact: false
 * therefore mirrors the API. Components that need several actions call this once per action in
 * ngOnInit() and keep the results in boolean flags.
 *
 * @param {RBACService} rbac The RBAC service used to evaluate the permissions.
 * @param {string} action One of the RBACService.RBAC_A actions.
 * @return {boolean} True when the user holds the action in either perspective.
 */
export function assetUserCanAccess(rbac: RBACService, action: string): boolean {
  return rbac.userCanAccess([
    RBACService.getPermission(RBACService.RBAC_F.F_REGISTERS_ASSETS, action),
    RBACService.getPermission(RBACService.RBAC_F.F_SITES_ASSETS, action)
  ], false);
}
